var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg21(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2891_50052)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.63281 11.88C2.66352 11.88 1.87492 12.6686 1.87492 13.638C1.87492 14.6073 2.66352 15.3959 3.63281 15.3959C4.60211 15.3959 5.3907 14.6073 5.3907 13.638C5.3907 12.6687 4.60211 11.88 3.63281 11.88ZM3.63281 14.224C3.30969 14.224 3.0468 13.9611 3.0468 13.638C3.0468 13.3148 3.30969 13.0519 3.63281 13.0519C3.95594 13.0519 4.21883 13.3148 4.21883 13.638C4.21883 13.9611 3.95594 14.224 3.63281 14.224Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7344 16.5819H11.959L10.5469 14.6834V11.5041H10.9961V10.3322H10.5469V9.39457H9.375V10.3322H8.87371V11.5041H9.375V14.6834L7.96289 16.5819H7.26562V6.93367H0V19.9805H20V6.93367H12.7344V16.5819ZM9.96094 15.8591L10.4985 16.5819H9.42336L9.96094 15.8591ZM1.17188 8.10555H6.09375V16.5819H1.17188V8.10555ZM18.8281 18.8086H1.17188V17.7538H18.8281V18.8086ZM13.9062 8.10555H18.8281V16.5819H13.9062V8.10555Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3672 11.88C15.3979 11.88 14.6093 12.6686 14.6093 13.638C14.6093 14.6073 15.3979 15.3959 16.3672 15.3959C17.3365 15.3959 18.1251 14.6073 18.1251 13.638C18.1251 12.6687 17.3365 11.88 16.3672 11.88ZM16.3672 14.224C16.0441 14.224 15.7812 13.9611 15.7812 13.638C15.7812 13.3148 16.0441 13.0519 16.3672 13.0519C16.6903 13.0519 16.9532 13.3148 16.9532 13.638C16.9532 13.9611 16.6903 14.224 16.3672 14.224Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0195312V1.19141H5.2177L4.26172 2.64574L7.16687 4.55531L8.1966 2.98875V4.70707H11.6732V2.98879L12.7029 4.55535L15.608 2.64578L14.6521 1.19141H20V0.0195312H0ZM7.37844 2.10004L6.83133 2.93242L5.88473 2.31016L6.43188 1.47777C6.51496 1.35137 6.6423 1.26488 6.79047 1.23426C6.93859 1.20352 7.08984 1.2325 7.21625 1.31559C7.47723 1.48715 7.55 1.83902 7.37844 2.10004ZM10.5013 3.5352H9.36852V2.14848C9.36852 1.83617 9.62262 1.58207 9.93492 1.58207C10.2472 1.58207 10.5013 1.83617 10.5013 2.14848V3.5352ZM13.0385 2.93242L12.4914 2.10004C12.3198 1.83902 12.3926 1.48715 12.6536 1.31559C12.7471 1.25414 12.8542 1.2223 12.9636 1.2223C13.002 1.2223 13.0408 1.22625 13.0794 1.23426C13.2275 1.26488 13.3549 1.35137 13.438 1.47781L13.9851 2.3102L13.0385 2.93242Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7812 9.29688H16.9531V10.5014H15.7812V9.29688Z",
    fill: "#222222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04688 9.29688H4.21875V10.5014H3.04688V9.29688Z",
    fill: "#222222"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2891_50052"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg21);
export default __webpack_public_path__ + "static/media/21.3f5e35269818c25198df51fa0d62f1fb.svg";
export { ForwardRef as ReactComponent };